<template>
  <div class="relative">
    <div
      v-if="configDashboard"
      class="flex items-center justify-between absolute z-10 p-6 w-full"
    >
      <h4>Queue Card</h4>
      <vs-chip
        transparent
        color="#FBA727"
        class="text-base text-center cursor-pointer"
        @click.native="removeQueueCard"
      >
        Remove
      </vs-chip>
    </div>
    <vx-card class=" p-3 md:p-6 overflow-hidden">
      <vs-row
        class="flex justify-between items-center"
        :class="configDashboard ? 'opacity' : ''"
      >
        <h3 class="mb-1">{{ $t('orgDashboard.userDashboard.activityQueue') }}</h3>
      </vs-row>
      <!-- Distributed items by org  -->
      <vs-row v-if="distributedItemSkeleton" class="px-3 pb-3">
        <vs-row v-for="i in 5" :key="i" class="p-8 skeleton rounded-lg my-2" />
      </vs-row>
      <div

        v-if="
          orgAndCourse && orgAndCourse.length > 0 && !distributedItemSkeleton
        "
      >
        <vs-row
        class="py-3"
          v-for="(org, index) in orgAndCourse"
          :key="index"
          :class="isItemsDistributed(org.courses) ? '' : 'hidden'"
        >
          <h5
            v-if="
              org.org &&
              org.org.organizationData &&
              org.org.organizationData.name &&
              org.courses &&
              org.courses.length > 0
            "
            class="px-6"
            style="color: #91919f !important"
          >
            Distributed by {{ org.org.organizationData.name }}
          </h5>
          <vs-row
            v-if="org.courses && org.courses.length > 0"
            class="px-3"
            :class="configDashboard ? 'opacity' : ''"
          >
            <vs-row
              class="items-center my-2"
              v-for="(activity, index) in org.courses"
              :key="index"
              :class="activity.status === 'doing' ? '' : 'hidden'"
            >
              <vs-col vs-w="3">
                <div class="h-12 w-12 overflow-none">
                  <img
                    class="w-full h-full object-cover rounded-full"
                    :src="
                      activity.imageUrl ? activity.imageUrl : randomFeedImage
                    "
                    @error="randomFeedImage"
                  /></div
              ></vs-col>
              <vs-col vs-w="7">
                <a
                  v-if="activity && activity.url && activity.title"
                  :href="activity.url"
                  target="_blank"
                  ><h6 class="text-left cropped-text">
                    {{ activity.title | title }}
                  </h6></a
                ></vs-col
              >
              <vs-col vs-w="2">
                <vs-icon
                  @click.native="
                    setDevelopmentStage({
                      status: 'done',
                      itemId: activity.itemId,
                      type: activity.type
                        ? activity.type
                        : activity.itemType
                        ? activity.itemType
                        : '',
                    });
                    $store.commit('modals/OPEN_CHAT_BOT_POPUP', true);
                  "
                  class="text-2xl rounded-full cursor-pointer"
                  :color="
                    activityDoneIds.includes(activity.itemId) ? '#5d9d7b' : ''
                  "
                  icon="icon-check-circle"
                  icon-pack="feather"
              /></vs-col>
            </vs-row>
          </vs-row>
        </vs-row>
      </div>
      <!-- Currently developing user skills  -->
      <vs-row
        class="text-center py-0 px-6"
        v-if="currentlyDevelopingData && currentlyDevelopingData.length"
        :class="configDashboard ? 'opacity' : ''"
      >
        <div class="items-left currently-developing" style="clear: both">
          <h5 class="mb-3" style="color: #91919f !important">
            Currently Developing
          </h5>
          <span
            v-for="(data, index) in currentlyDevelopingData"
            :key="index"
            class="right-panel--item-currently-developing m-1 ml-0"
          >
            {{
              data.title ||
              getPersonalityTraitById(data.id).title ||
              getPersonalityTraitById(data).title
            }}
          </span>
        </div>
      </vs-row>
      <vs-row v-if="!distributedItemSkeleton">
        <vs-row v-if="activitySkeleton" class="px-3 pb-3">
          <vs-row
            v-for="i in 5"
            :key="i"
            class="p-8 skeleton rounded-lg my-2"
          />
        </vs-row>

        <vs-row
          v-if="activityArray && activityArray.length > 0 && !activitySkeleton"
          class="px-3 pb-3"
          :class="configDashboard ? 'opacity' : ''"
        >
          <vs-row
            class="items-center my-2"
            v-for="(activity, index) in activityArray"
            :key="index"
          >
            <vs-col vs-w="3">
              <div class="h-12 w-12 overflow-none">
                <img
                  v-if="activity && activity.imageUrl"
                  class="w-full h-full object-cover rounded-full"
                  :src="activity.imageUrl"
                  @error="randomFeedImage"
                /></div
            ></vs-col>
            <vs-col vs-w="7">
              <a
                v-if="activity && activity.url"
                :href="activity.url"
                target="_blank"
                ><h6 class="text-left cropped-text">
                  {{ activity.title | title }}
                </h6></a
              ></vs-col
            >
            <vs-col vs-w="2">
              <vs-icon
                @click.native="
                  setDevelopmentStage({
                    status: 'done',
                    itemId: activity.itemId,
                    type: activity.type
                      ? activity.type
                      : activity.itemType
                      ? activity.itemType
                      : '',
                  })
                "
                class="text-2xl rounded-full cursor-pointer"
                :color="
                  activityDoneIds.includes(activity.itemId) ? '#5d9d7b' : ''
                "
                icon="icon-check-circle"
                icon-pack="feather"
            /></vs-col>
          </vs-row>
        </vs-row>

        <vs-row
          v-if="
            activityArray && activityArray.length === 0 && !activitySkeleton
          "
          class="py-2"
          :class="configDashboard ? 'opacity' : ''"
        >
          <vs-col class="flex items-center">
            <img
              class="lg:w-24 w-64"
              src="@/assets/images/temp-img/empty-queue.svg"
            />
            <h5 class="ml-4 md:ml-2 text-sm text-left text-slate-600">Add items to your queue from Development Charter.</h5>
          </vs-col>
        </vs-row>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import constants from "@/constants";
import organizationConfig from "@/assets/data/organization-config.js";
export default {
  data() {
    return {
      editActiveQueueCard: false,
      constants,
      organizationConfig,
      activityArray: [],
      distributedItems: [],
      activitySkeleton: true,
      distributedItemSkeleton: true,
      activityDoneIds: [],
      // orgAndCourse: [],
    };
  },

  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    userWidgets() {
      return this.$store.state.dashboard.userWidgets;
    },
    configDashboard() {
      return this.$store.state.dashboard.configDashboard;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      if (
        this.userOrganizations &&
        this.userOrganizations[0].organizationData.slug === "gala"
      )
        return this.organizationConfig["gala"].personalityTraits[this.locale];
      else
        return this.organizationConfig["default"].personalityTraits[
          this.locale
        ];
    },
    currentlyDevelopingData() {
      let cd = [];
      if (
        this.userData &&
        this.userData.extraCurricular &&
        this.userData.extraCurricular[0] &&
        this.userData.extraCurricular[0].skills &&
        this.userData.extraCurricular[0].skills.length &&
        this.userData.extraCurricular[0].skills.findIndex((skill) => {
          return Boolean(skill.activateLearning) === true;
        }) !== -1
      ) {
        cd = this.userData.extraCurricular[0].skills.filter((skill) => {
          return Boolean(skill.activateLearning) === true;
        });
      }

      if (this.galaAbilities || this.galaAbilities.length > 0) {
        cd = [
          ...cd,
          ...this.galaAbilities.filter((p) => {
            return (
              this.galaPriorities &&
              this.galaPriorities[p] !== undefined &&
              this.galaPriorities[p] !== null
            );
          }),
        ];
      }

      if (
        this.userData &&
        this.userData.personality &&
        this.userData.personality[0] &&
        this.userData.personality[0].personalityTraits &&
        this.userData.personality[0].personalityTraits.length &&
        !this.galaAbilities &&
        this.galaAbilities.length === 0 &&
        !this.galaPriorities &&
        Object.keys(this.galaPriorities).length === 0
      ) {
        cd = [
          ...cd,
          ...this.userData.personality[0].personalityTraits.filter((p) => {
            return p.priorityNumber !== null && p.priorityNumber !== undefined;
          }),
        ];
      }
      if (cd.length > 0) return cd;
      return null;
    },
    doingItems() {
      return this.$store.state.feed.doingItems;
    },
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    galaAbilities() {
      return this.$store.state.users.galaAbilities;
    },
    galaPriorities() {
      return this.$store.state.users.galaPriorities;
    },
    orgAndCourse() {
      return this.$store.state.feed.distributedItems;
    },
  },
  watch: {
    doingItems: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.activityArray = newVal;
        this.activitySkeleton = false;
      },
    },
    orgAndCourse: {
      deep: true,
      immediate: true,
      handler(newVal) {
        setTimeout(() => {
          this.distributedItemSkeleton = false;
        }, 1500);
        return newVal;
      },
    },
  },
  methods: {
    getPersonalityTraitById(id) {
      if (id) {
        const p = this.personalityData.find((pd) => {
          return (
            pd.id === id ||
            pd.personalityMapId - 36 === id ||
            pd.personalityMapId === id
          );
        });
        return p;
      }
      return {};
    },
    removeQueueCard() {
      const queueCard = this.userWidgets.find(
        (item) => item.widgetId === "ACTIVITY_QUEUE"
      );
      this.$store
        .dispatch("dashboard/removeWidget", queueCard)
        .then(() => {
          for (var i = 0; i < this.userWidgets.length; i++) {
            if (this.userWidgets[i].widgetId === "ACTIVITY_QUEUE") {
              this.$store.commit("dashboard/REMOVE_WIDGET", i);
            }
          }
          this.$store.commit("dashboard/SHOW_QUEUE_CARD", false);
        })
        .catch((err) => {
          throw err;
        });
    },
    setDevelopmentStage(i) {
      const payload = {
        type: i.type,
        getboardedId: this.userData._id,
        itemId: i.itemId,
        status: i.status,
      };
      this.status = i.status;
      this.$store
        .dispatch("feed/updateCourseStatus", payload)
        .then(() => {
          return this.activityDoneIds.push(i.itemId);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.disableLink = false;
        });
    },
    fetchDoingItems() {
      this.activitySkeleton = true;
      this.$store
        .dispatch("feed/doingItems", this.userData._id)
        .then((res) => {
          if (!res || !Array.isArray(res)) {
            this.activityArray = [];
          } else {
            this.activityArray = res;
          }
        })
        .catch(() => {
          this.activityArray = [];
        })
        .finally(() => {
          this.activitySkeleton = false;
        });
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    isItemsDistributed(courses) {
      for (let i = 0; i < courses.length; i++) {
        if (courses[i].status === "doing") {
          return true;
        }
      }
    },
  },
  mounted() {
    this.fetchDoingItems();
  },
};
</script>

<style lang="scss" scoped>
$bg: #fba62742;
$color: #fba727;
.icon-bg {
  background-color: $bg;
}
.skills-btn {
  color: $color !important;
  background: $bg;
}

.skeleton {
  background: #808080;
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
.vx-card ::v-deep .vx-card__body {
  padding: 0;
}
.opacity {
  opacity: 0.075;
}

.right-panel--item-currently-developing {
  background: rgba(242, 146, 0, 0.1);
  border-radius: 1000px;
  color: #f29200;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.cropped-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
